import { Component, OnInit,ViewChild,ChangeDetectorRef,Output,EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';

import {
  ClientSideRowModelModule,
  RowGroupingModule,
  ColDef,
  GridApi,
  GridReadyEvent,
  ModuleRegistry,
  RowGroupingDisplayType,
  RowClassParams,
  RowStyle,
  UseGroupTotalRow
}

from 'ag-grid-enterprise';

////import {  } from 'ag-grid-enterprise'

//ModuleRegistry.registerModules([
//  ClientSideRowModelModule,
//  RowGroupingModule
//])

import { LoggingService } from 'src/app/services/logging.service';
import { FormTasksEntryComponent } from '../form-tasks-entry/form-tasks-entry.component';
import { FormEntryComponent } from '../form-entry/form-entry.component';
import { CalendarSlimComponent } from '../../calendar-slim/calendar-slim.component';
import { AppModule } from '../../../../app.module';
import 'chosen-js';
import * as dayjs from 'dayjs';
import 'dayjs/plugin/duration';
import * as tz from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';
import * as weekfinder from 'dayjs/plugin/weekOfYear';
import { HourglassService } from 'src/app/services/hourglass.service';
import { TabSendWeeklyUpdateComponent } from '../tab-send-weekly-update/tab-send-weekly-update.component';

dayjs.extend(weekfinder);
dayjs.extend(tz);
dayjs.extend(utc);

@Component({
  selector: 'app-tab-entry',
  templateUrl: './tab-entry.component.html',
  styleUrls: ['../hourglass.component.css']
})
export class TabEntryComponent {
  @Output() setImpersonateFilter = new EventEmitter<any>();
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  @ViewChild(FormTasksEntryComponent) taskEntry!: FormTasksEntryComponent;
  @ViewChild(FormEntryComponent) formEntry!: FormEntryComponent;
  @ViewChild(TabSendWeeklyUpdateComponent) tabWeekly!: TabSendWeeklyUpdateComponent;
  @ViewChild(CalendarSlimComponent) calendarWidget!: CalendarSlimComponent;

  token!: string;
  gridApi!: GridApi<any>;
  entryForm: any = {
    employeeID: "",
    taskID: "",
    taskIDArray: [],
    entryDt: dayjs(Date.now()).format('DD-MM-YYYY'),
    entryStart: "",
    entryEnd: "",
    entryNotes: "",
    entryBillable: "0",
    entryDuration: "-",
    entryDurationHrs: 0,
    entryDurationMins:0,
    entryTimeZone: "EST",
    entryAssignees: [],
    entryAssigneeNames: [],
    entryFormat:"startduration"
  };
  gridFilters = {
    searchText: "",
    timeWeekKey: [dayjs(new Date()).year(), dayjs(new Date()).week()].join('_'),
    timeWeek: dayjs(new Date()).week(),
    timeYear: dayjs(new Date()).year()
  };
  scoreCards = {
    billable: '',
    internal: '',
    total:''
  };
  lastCol = "";
  listTags: any[] = [];
  listEmployees: any[] = [];
  listEntries: any[] = [];
  listTasks: any[] = [];
  listTimeWeeks: any[] = [];
  rowData: any[] = [];
  columnDefs: ColDef[] = [];
  editedRows: Set<number> = new Set();
  errorMessage = "";
  pageSize = true;
  rowSelection: any = "single";
  saveMode = "add";
  showDevNotes = false;
  showModal = "none";
  tableName: any;
  userID: any = sessionStorage.getItem('wOSImpersonate') || sessionStorage.getItem('wOSAuthUser') || "";
  authUser: any = sessionStorage.getItem('wOSAuthUser');
  authAdmin: any = sessionStorage.getItem('wOSAdmin');
  impersonatedUser: any = this.userID;
  groupColumnDef: ColDef = { minWidth: 150, headerName: "Entry Date", cellRenderer:"agGroupCellRenderer" };
  groupDefaultExpanded = 0;
  groupTotalRow: "top" | "bottom" | UseGroupTotalRow = "bottom";
  suppressAggFuncInHeader = true;
  defaultColDef: ColDef = { flex: 1, minWidth: 100 };
  groupDisplayType: RowGroupingDisplayType = "groupRows";

  constructor(
    private hourglassService: HourglassService,
    private route: ActivatedRoute,
    private loggingService: LoggingService,
    private changes: ChangeDetectorRef,
    private appModule: AppModule
  ) { }

  onGridReady(params: GridReadyEvent): void {
    const user: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(user).stsTokenManager.accessToken;
    this.gridApi = params.api;
    this.formEntry.entryForm.entryFormat = this.entryForm.entryFormat;
    this.getUXData(this.userID, "all");

    $('#sel_task').on('change', () => {
      this.entryForm.taskID = String($('#sel_task').val());
    })
  }

  getUXData(user: string, mode: string): void {
    this.gridApi.setGridOption('loading',true)

    this.hourglassService.getTimeEntryUxData(user, mode, this.gridFilters, this.token).then((data) => {
    
      // only load employees the first time - list won't change
      if (this.listEmployees.length == 0) {
        this.listEmployees = data.employees;
        this.setImpersonateFilter.emit(this.listEmployees);
      }

      this.listTasks = data.tasks;
      this.listEntries = data.entries;
      this.listEntries.forEach(e => {
        if (e.t_date) {
          e.t_date = dayjs(e.t_date).format('YYYY-MM-DD');
        }
      });
      this.listTimeWeeks = data.timeweeks;
      this.entryForm.employeeID = user;
      this.formEntry.userID = user;
      this.formEntry.loadFromEntryTab(data);

      const obj = this.listEntries[0] || null;
      
      this.scoreCards.billable = (obj == null) ? '0' : this.calculateDuration(obj.billable_total);
      this.scoreCards.internal = (obj == null) ? '0' : this.calculateDuration(obj.internal_total);
      this.scoreCards.total = (obj == null) ? '0' : this.calculateDuration(obj.internal_total+obj.billable_total);

      if (this.listEntries.length > 0) {
        this.gridApi.setGridOption('loading', true);
        this.buildColumnSpec(this.listEntries);

        setTimeout(() => {
          const h = (this.listEntries.length) * 32;
          $('#sizeTimeEntries').height(h);
          this.gridApi.setGridOption('rowData', this.listEntries);
          this.gridApi.sizeColumnsToFit();
          this.gridApi.setGridOption('loading', false);
        });
      } else {
        this.gridApi.setGridOption('rowData', []);
        $('#sizeTimeEntries').height(350);
        this.gridApi.setGridOption('loading', false);
      }
    })
  }

  calculateDuration(minutes: number): string {
    const minscalc = (minutes % 60);
    const hrscalc = (minutes - minscalc) / 60;
    return ((hrscalc > 0) ? hrscalc + 'h' : '') + ' ' + minscalc + 'm';
  }

  refreshEntryGrid(user: string): void {
    this.getUXData(user, "all");
  }

  handleTaskChanges(params: any) {
    this.getUXData(this.userID, "all");

    setTimeout(() => {
      this.entryForm.taskID = params;
      this.formEntry.refreshFromTaskAdd(this.entryForm.taskID);
      this.toggleModal('close');
    });
  }

  resetGrid(message: string): void {
    this.gridApi.deselectAll();
  }

  toggleDevNotes(): void {
    this.showDevNotes = !this.showDevNotes;
  }

  trackByFn(index: any, record: any) {
    return record.id
  }

  filterGridData(): void {
    try {
      const aParms = this.gridFilters.timeWeekKey.split("_");
      this.gridFilters.timeWeek = parseInt(aParms[1]) || 0;
      this.gridFilters.timeYear = parseInt(aParms[0]) || 0;
      
      const week = this.listTimeWeeks.find((x) => x.id == this.gridFilters.timeWeekKey);
      
      // limit the date selector to the selected week
      this.formEntry.entryForm.entryMinDt = dayjs(week.wkstart).format("YYYY-MM-DD");
      this.formEntry.entryForm.entryMaxDt = dayjs(week.wkend).format("YYYY-MM-DD");
      

      // default to the first day of the selected week
      this.formEntry.entryForm.entryDt = this.formEntry.entryForm.entryMinDt;
      this.getUXData(this.userID, "all");

      // if not impersonating, refresh the calendar data widget
      if (this.authUser == this.userID) { 
        this.calendarWidget.fromDt = dayjs(week.wkstart).format("YYYY-MM-DD");
        this.calendarWidget.thruDt = dayjs(week.wkend).format("YYYY-MM-DD");
        this.calendarWidget.loadCalendarEvents();
      }
    } catch (ex) {
      console.log("wOS ERROR","filterGridData",ex)
    }
  }

  // called when a calendar event is clicked - originates from calendar-slim.component.ts
  populateFromCalendar(params: any) {
    const key = params.returnID;
    
    if (key > 0) {
      this.entryForm.taskID = key;
      this.formEntry.entryForm.taskID = key;
      this.formEntry.getTaskAssignees();
      this.formEntry.entryForm.entryDt = dayjs(params.start.dateTime).format("YYYY-MM-DD");
      this.formEntry.entryForm.entryStart = dayjs(params.start.dateTime).format("HH:mm");
      this.formEntry.setEntryType(params.summary);
      this.formEntry.setTaskFilter();

      const end = dayjs(params.end.dateTime)
      const start = dayjs(params.start.dateTime)
      const mins = end.diff(start, "minutes");
      const minscalc = (mins % 60);
      const hrscalc = (mins - minscalc) / 60;

      this.formEntry.entryForm.entryDurationHrs = hrscalc;
      this.formEntry.entryForm.entryDurationMins = minscalc;
      $('#ta_notes').trigger('focus');
    } else {

      $('#entryModal .modal-title').html("<i class='fas fa-fw fa-lg fa-check me-1'></i>Add Task");
      this.toggleModal('show');
      this.taskEntry.taskMode = 'choose';
      this.taskEntry.loadFromCalendar(params);
    }
  }

  // called when "use existing task is clicked" from a calendar event - originates from calendar-slim.component.ts
  populateFromExisting(params: any) {
    const end = dayjs(params.end.dateTime)
    const start = dayjs(params.start.dateTime)
    const mins = end.diff(start, "minutes");
    const minscalc = (mins % 60);
    const hrscalc = (mins - minscalc) / 60;
    
    this.formEntry.entryForm.entryDt = dayjs(params.start.dateTime).format("YYYY-MM-DD");
    this.formEntry.entryForm.entryStart = dayjs(params.start.dateTime).format("HH:mm");
    this.formEntry.setEntryType(params.summary);
    this.formEntry.entryForm.entryDurationHrs = hrscalc;
    this.formEntry.entryForm.entryDurationMins = minscalc;
    this.toggleModal('hide');
    $('#sel_task').trigger('focus');
    
  }


  cellRenderer(params: any) {
    let template:any = '';
    let tmp: any = '';
    let data = 0;
    let hrs = 0;
    let mins = 0;

    //console.log(params.colDef.field)

    switch (params.colDef.field) {
      case 't_start':
      case 't_end':
        tmp = dayjs.utc(params.getValue());
        template = tmp.tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('h:mm A');
        break;
      case 'duration':
        data = params.getValue();
        mins = (data % 60);
        hrs = (data - mins) / 60;
        template = ((hrs > 0) ? hrs + 'h' : '') + ' ' + mins + 'm'
        break;
      case 'notes':
      case 't_name':
      case 'entry_type_desc':
        template = params.getValue();
        break;
      case 'billable':
        template = (params.getValue() == 1) ? '<i class="fas fa-fw  fa-check c_green"></i>' : '<i class="fas fa-fw fa-times c_red"></i>';
        break;
      default:
        //template = '';
        template = params.getValue();
        break;
    }
    return template;
  }

  searchChange(): void {
    const term = this.gridFilters.searchText;
    this.gridApi.setGridOption('quickFilterText', term);
  }

  clearSearch(): void {
    this.gridFilters.searchText = "";
    this.gridApi.setGridOption('quickFilterText', this.gridFilters.searchText);
  }

  resetEntry(): void {
    this.entryForm.id = 0;
    this.entryForm.taskID = "";
    this.entryForm.taskObject = [];
    this.entryForm.entryDt = dayjs(Date.now()).format('YYYY-MM-DD');
    this.entryForm.entryStart = "";
    this.entryForm.entryEnd = "";
    this.entryForm.entryNotes = "";
    this.entryForm.entryBillable = "1";
    this.entryForm.entryDurationHrs = 0;
    this.entryForm.entryDurationMins = 30;
    this.saveMode = "add";
    this.gridApi.deselectAll();
    $('#sel_entrytype').trigger('focus');
  }
  
  toggleModal(mode: string) {
    this.showModal = (mode == 'show') ? "show" : "hide";
    ($('#entryModal') as any).modal(this.showModal);
  }

  buildColumnSpec(table: any): any {
    const tbl = [
      't_date', 'entry_type', 'entry_type_desc',
      't_name', 't_start', 't_end',
      'duration', 'notes', 'billable',
      't_description', 'clients', 'assignees',
      'assignee_names', 'entry_owner', 'id',
      'task_id', 'delete'
    ];
  
    const labels: any[] = [
      'Entry Date', 'Entry Type ID', 'Entry Type',
      'Task Name', 'Start Time', 'End Time',
      'Duration', 'Notes', 'Billable',
      'Task Desc', 'Client(s)', 'Assignees',
      'Assignee Names', 'Owner', 'Entry ID',
      'Task ID', ''
    ];
    const alignments: any[] = [
      'left', 'left', 'left',
      'left', 'center', 'center',
      'end', 'left', 'center',
      'center', 'center', 'left',
      'left', 'left', 'center',
      'left','center'
    ];
    const widths: any[] = [
      0, 0, 0,
      300, 100, 100,
      100, 300, 100,
      100, 100, 100,
      0, 0, 0,
      0, 75
    ];
    const hides: any[] = [
      'id', 'assignees', 'assignee_names',
      'task_id', 't_description', 'entry_owner',
      'billable','entry_type','entry_type_desc'
    ];
    const expander = 'notes';

    //console.log(labels.length,alignments.length,widths.length)

    let i = 1;
  
    this.columnDefs = tbl.map((col) => {
      let returnedColDef = {};
  
      const baseColDef = {
        cellClass: ['text-' + alignments[i - 1]],
        field: col,
        headerName: labels[i - 1],
        headerTooltip: labels[i - 1],
        headerClass: 'text-center',
        editable: false,
        sortable: true,
        filter: false,
        resizable: true,
        width: widths[i - 1],
        tooltipField: col,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: (col == expander) ? false : true,
        cellRenderer: this.cellRenderer,
        cellDataType: (col == 'billable') ? 'boolean' : '',
        hide: (hides.includes(col.toLowerCase())) ? true : false

      };
  
      if (col === 't_date') {
        returnedColDef = {
          ...baseColDef,
          rowGroup: true,
          hide: true, // show the column
          cellRenderer: (params: any) => {
            // only show date for leaf rows, not group headers
            if (params.node.group) return '';
            return params.value;
          }
        };
      } else if (col === 'duration') {
        returnedColDef = {
          ...baseColDef,
          valueFormatter: (params: any) => {
            const total = Number(params.value);
            if (!total || isNaN(total)) return '';
            const mins = total % 60;
            const hrs = Math.floor(total / 60);
            return `${hrs}h ${mins}m`;
          },
          aggFunc: 'sum'
        };
      } else if (col === 'delete') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const owner = params.data.entry_owner;
            const div = document.createElement('div');
            const del = document.createElement('span');
            const copy = document.createElement('span');
  
            if (owner == this.userID) {
              copy.className = 'pointer';
              copy.innerHTML = (!params.data.isBlank) ?
                `<i class="fas fa-fw fa-copy c_blue m-1" title="Copy Entry" id="copy_${params.data.id}"></i>` : ``;
  
              copy.addEventListener('click', (e: any) => {
                e.stopPropagation();
                const key = e.srcElement.id.split('_')[1];
                this.copyEntry(key);
              });
  
              del.className = 'pointer';
              del.innerHTML = (!params.data.isBlank) ?
                `<i class="fas fa-fw fa-trash c_bluedk" title="Delete Row ${params.data.id}" id="del_${params.data.id}"></i>` : ``;
  
              del.addEventListener('click', (e: any) => {
                e.stopPropagation();
                const key = e.srcElement.id.split('_')[1];
                const answer = confirm('Are you sure you want to delete this time entry?');
                if (answer) this.deleteClick(key);
              });
  
              div.appendChild(copy);
              div.appendChild(del);
            } else {
              div.innerHTML = `<i class="fas fa-fw fa-lock c_red" title="Entry created by ${params.data.owner_name} and can't be modified."></i>`;
            }
            return div;
          },
          cellRendererParams: { table_name: this.tableName },
          field: `id`,
          cellClass: 'text-center',
          pinned: 'right',
          suppressHeaderMenuButton: true,
          suppressHeaderFilterButton: true,
          resizable: false
        };
      } else {
        returnedColDef = baseColDef;
      }
  
      i++;
      return returnedColDef;
    });
  
    // Custom group row display for summed duration
    this.groupRowRendererParams = {
      suppressCount: true,
      innerRenderer: (params: any) => {
        const { value, node } = params;
        const weekday = dayjs(value).format('ddd'); // add weekday name to group headers
        const dtstamp = dayjs(value).format('DD MMM');


        let billableTotal = 0;
        let nonBillableTotal = 0;
        let total = 0;
    
        // Walk the children and sum durations
        node.childrenAfterFilter?.forEach((child: any) => {
          const duration = child.data?.duration || 0;
          const isBillable = child.data?.billable === 1;
          total += duration;
          if (isBillable) {
            billableTotal += duration;
          } else {
            nonBillableTotal += duration;
          }
        });
    
        // Helper to format minutes into "Xh Ym"
        const formatDuration = (mins: number) => {
          const hrs = Math.floor(mins / 60);
          const rem = mins % 60;
          return `${hrs}h ${rem}m`;
        };
    
        return `
        <span style="font-weight:normal !important">
          <strong class="me-3">${weekday} ${dtstamp}</strong>
          <span class="c_blue me-3">Total: ${formatDuration(total)}</span> 
          <span class="c_green me-3">Billable: ${formatDuration(billableTotal)}</span> 
          Non-Billable: ${formatDuration(nonBillableTotal)}</span>
        </span>
        `;
      }
    };
  }

  copyEntry(key: number) {
    const row = this.listEntries.find(e => e.id == key);
    this.loadFromCopy(row);
  }

  deleteClick(key: number): void {
    const params = { "mode": "delete", "entity": "entry", "id": key.toString() };
    this.gridApi.setGridOption('loading', true);
    this.hourglassService.saveTimeEntryEntity(params, this.token).then(r => {
      this.getUXData(this.userID, "all");
      this.changes.detectChanges();
      this.gridApi.sizeColumnsToFit();
      this.gridApi.setGridOption('loading', false);
    })
  }

  getRowStyle = (params: RowClassParams): RowStyle | undefined => {
    // Apply style to group rows
    if (params.node.group) {
      return {
        backgroundColor: 'var(--welarabonemd)',
        fontWeight: 'bold'
      };
    }

    const rowData = params.node.data;
    if (rowData.billable == 1)
      return {
        backgroundColor: 'var(--welaragreenlt)'   
      }
 
    return undefined;
  };

  groupRowRendererParams = {
    suppressCount: false,
    innerRenderer: (params: any) => {
      const { value, node } = params;
      const aggData = node.aggData || {};
      const currencySum = aggData['Account Value'] || 0;
      return `<span>${value} (Total: $${currencySum.toLocaleString()})</span>`;
    },
  };

  onSelectionChanged(event: any) {
    if (event.source != "apiSelectAll") {
      try {
        this.gridApi.setGridOption('loading', true);

        // set save mode to edit and get reference to the current row data
        this.saveMode = "edit";
        const selectedRows = this.gridApi.getSelectedRows();
        const rowdata: any = selectedRows[0];

        if (rowdata !== undefined) {
          this.entryForm.id = rowdata.id;
          this.entryForm.employeeID = rowdata.user_id;
          this.entryForm.taskID = rowdata.task_id;
          this.entryForm.entryDt = dayjs(rowdata.t_date).format("YYYY-MM-DD");

          let tmptime = dayjs.utc(rowdata.t_start);
          let template = tmptime.tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('HH:mm');
          this.entryForm.entryStart = template;
          
          tmptime = dayjs.utc(rowdata.t_end);
          template = tmptime.tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('HH:mm');

          this.entryForm.entryEnd = template;
          this.entryForm.entryAssignees = rowdata.assignees.split(',');
          this.entryForm.entryAssigneeNames = rowdata.assignee_names.split(',');
          this.entryForm.entryBillable = rowdata.billable;
          this.entryForm.entryNotes = rowdata.notes;
          this.formEntry.loadFromGrid(rowdata);
        }
        this.gridApi.setGridOption('loading', false);
      } catch (ex) {
        console.log("Error onSelectionChanged",ex)
      }
    }
  }

  loadFromCopy(row: any) {
        this.gridApi.setGridOption('loading', true);

        // set save mode to edit and get reference to the current row data
        this.saveMode = "add";
        const rowdata: any = row;

        if (rowdata !== undefined) {
          this.formEntry.saveMode = "add"
          rowdata.t_date = "";
          rowdata.id = "";
          this.formEntry.loadFromGrid(rowdata,"copy");
        }
        this.gridApi.setGridOption('loading', false);

  }

  setFromImpersonate(user: any): void {
    console.log("setFromImpersonate", user)
  }

  clearErrorMessage(delay:any = 3500): void {
    setTimeout(() => {
      this.errorMessage = '';
    },delay)
  }
}
